export default function setupServerBannerTabs() {
	// find all server-side rendered containers with banners
	const serverBannerTabsContainers = document.querySelectorAll<HTMLElement>('.roc-banner-tabs');

	if (!serverBannerTabsContainers) {
		return;
	}

	serverBannerTabsContainers.forEach((container) => {
		const tabButtons = container.querySelectorAll<HTMLButtonElement>('.roc-banner-tabs__tab-button');

		const tabBanners = container.querySelectorAll<HTMLButtonElement>('.roc-banner-tabs__tab-content-item');

		if (!tabButtons) {
			console.warn('Banner tab buttons were not found. Exiting function setupServerBannerTabs.');
			return;
		}

		tabButtons.forEach((button) => {
			const tabIndex = button.dataset.tab;

			button.addEventListener('click', () => {
				tabBanners.forEach((banner) => {
					if (banner.dataset.tab === tabIndex) {
						banner.classList.add('roc-banner-tabs__tab-content-item--active');
					} else {
						banner.classList.remove('roc-banner-tabs__tab-content-item--active');
					}
				});

				tabButtons.forEach((button) => {
					if (button.dataset.tab === tabIndex) {
						button.classList.add('roc-banner-tabs__tab-button--active');
					} else {
						button.classList.remove('roc-banner-tabs__tab-button--active');
					}
				});
			});
		});
	});
}
